import moment, { unitOfTime } from "moment";

export function diffNow(iso: string, unitOfTime: unitOfTime.Diff = 'days') {
	return moment().diff(moment(iso), unitOfTime);
}
